module.exports = __webpack_public_path__ + "static/img/5.95dbd9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nationalDay/card/5.png
// module id = kxFG
// module chunks = 2